module.exports = __webpack_public_path__ + "img/1681190825355.58f55c5c.png";